const NotifyError = (error, customMessage = "", context = {}) => {
  console.log(error)
};

export default NotifyError;
